// App slugs for different apps
export const appSlugs = {
  docuStorage: "docu",
  technet: "tech-net",
  bdLead: "bd-lead",
  cfApproval: "cf-approval",
  cfApprovalV2: "cf-approval-v2",
  subs: "subs",
  qnet: "qnet",
  pettyExpense: "petty-expense",
  trainingManual: "training-manual",
  policies: "policies",
  franchisePolicy: "franchise-policy",
  vendorInvoiceSubmission: "vendor_invoice_submission",
  invoiceTracking: "invoice_tracking",
  subwayFinace: "subway_finance",
  plReport: "pl-report",
  electricityConsumption: "electricity-consumption",
  operationKPI: "operations-kpi",
  pdfSignatureManager: "pdf-signature-manager",
  financeV2: "finance_v2"
};
//name that we store in localstorage
export const tokenMainKeys = {
  docuStorage: "subway-docu",
  bdLead: "subwaylead",
  cfApproval: "subwayofapproval",
  technet: "tech-net",
  invoiceTracking: "subway-invoice-tracking",
  intranet: "subway",
  subs: "subs",
  qnet: "qnet",
  pettyExpense: "petty-expense",
  storeMaster: "subwayStoreMaster",
  vendorOnboard: "subway-vendor-onboard",
  subwayFinance: "subway-finance",
  trainingManual: "training-manual",
  policies: "policies",
  franchisePolicy: "franchise-policy",
  vendorInvoiceSubmission: "vendor-invoice-submission",
  plReport: "pl-report",
  electricityConsumptionTable: "electricity-consumption",
  operationKPI: "operations-kpi",
  cfApprovalV2: "subwaycfapprovalv2",
  pdfSignatureManager: "subway-pdf-signature-manager",
  financeV2: "finance-v2"
};

export const DATE_FORMATS = {
  "DD.MM.YYYY": "DD.MM.YYYY",
  "DD-MM-YYYY": "DD-MM-YYYY",
  "DD.MM.YYYY hh:MM": "DD.MM.YYYY hh:MM",
  "DD MMM YY hh:MM": "DD MMM YY hh:MM",
  "MMM DD YYYY hh:MM": "MMM DD YYYY hh:MM",
  "YYYY-MM-DD": "YYYY-MM-DD"
};
